export const styles = {
    sectionTitle: "tw-text-sm tw-text-[#6D788C] tw-font-semibold tw-px-4 tw-pb-2  tw-my-4 tw-border-b tw-border-[#D1D1D6]",
    subSectionTitle: "tw-text-sm tw-text-[#6D788C] tw-mb-2",
    container: "",
    section: "tw-my-4 tw-mx-4",
    uploadButton: "tw-w-full tw-py-1 tw-text-sm tw-px-4 tw-border tw-border-[#091CAA] tw-rounded tw-text-[#091CAA] tw-text-center",
    checkboxContainer: "tw-flex tw-items-center tw-mb-2",
    checkboxInput: "tw-mr-2 tw-border tw-border-[#D1D1D6] tw-text-[#6D788C] tw-font-medium tw-text-xs tw-accent-[#091CAA]",
    checkboxLabel: "tw-text-sm tw-text-[#172B4D] tw-font-semibold",
    checkboxLabelSmall: "tw-text-xs tw-font-semibold tw-text-[#172B4D]",
    nestedContainer: "tw-pl-6",
    nestedInputContainer: "tw-mb-2",
    nestedInputContainerWithMargin: "tw-mb-2 tw-ml-5",
    inputLabel: "tw-block tw-font-semibold tw-text-xs tw-text-[#6D788C] tw-pb-1",
    input: "tw-w-full tw-border tw-border-[#D1D1D6] tw-text-[#172B4D] tw-font-medium tw-text-sm tw-rounded tw-px-3 tw-py-2",
    selectContainer: "tw-relative",
    select: "tw-w-full tw-appearance-none tw-border tw-border-[#DADBDD] tw-rounded tw-px-3 tw-py-2 tw-pr-8 tw-font-semibold tw-text-[#172B4D] tw-text-sm tw-bg-white",
    selectIcon: "tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-pointer-events-none",
    radioGroup: "tw-flex tw-items-center tw-space-x-4",
    radioLabel: "tw-flex tw-items-center",
    radioInput: "tw-mr-2 tw-accent-[#091CAA]",
};